import React from 'react';
import { FiClipboard } from 'react-icons/fi';

/**
 * ClipboardIcon
 * Ikona schránky pre označenie obsahu pripraveného na skopírovanie.
 */
const ClipboardIcon = ({ className = 'inline-block align-middle', ...props }) => (
  <FiClipboard className={className} {...props} />
);

export default ClipboardIcon;

